// extracted by mini-css-extract-plugin
export var card = "RnZLS";
export var cards = "mTpuX";
export var isExpanded = "wvvoy";
export var main = "lrRPt";
export var title = "Gdlil";
export var viewMore = "RR9uX";